"use client";

import { useReportWebVitals } from "next/web-vitals";

export function WebVitals() {
	useReportWebVitals((metric) => {
		console.info(metric);
	});
	return null;
}
